import React from 'react';
import { motion } from 'framer-motion';

const clients = [
 { 
  name: "Indian Vedic Astrologer", 
  cat: "Astrology", 
  url: "https://indianvedicastrologer.nl/", 
  color: "#6C47FF", 
  tagline: "Dutch-based vedic wisdom platform",
  image: "https://images.pexels.com/photos/207529/pexels-photo-207529.jpeg?w=600&h=400&fit=crop",
  logoBg: "#F0EBFF"
},
  { 
    name: "Capital Infra", 
    cat: "Real Estate", 
    url: "https://capitalinfra.org/", 
    color: "#0F67B3", 
    tagline: "Premium real estate development",
    image: "https://images.unsplash.com/photo-1448630360428-65456885c650?w=600&h=400&fit=crop",
    logoBg: "#E6F2FC"
  },
  { 
    name: "Evaluate Solution", 
    cat: "HR Services", 
    url: "https://evaluatesolutionservices.com/", 
    color: "#0F8B5E", 
    tagline: "Streamlined HR & evaluation services",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop",
    logoBg: "#E0F7EE"
  },
  { 
    name: "URK Ayurveda", 
    cat: "E-Commerce", 
    url: "https://urkayurveda.com/", 
    color: "#3F8C3A", 
    tagline: "Authentic ayurvedic e-commerce",
    image: "https://images.unsplash.com/photo-1544365558-35df4afd6e45?w=600&h=400&fit=crop",
    logoBg: "#EBF5E8"
  },
  { 
    name: "Motilal Global", 
    cat: "Infotech", 
    url: "https://motilalglobal.com/", 
    color: "#D98A2C", 
    tagline: "Global technology solutions",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&h=400&fit=crop",
    logoBg: "#FEF3E6"
  },
  { 
    name: "Maxoto", 
    cat: "Automotive", 
    url: "https://maxoto.com/", 
    color: "#D14529", 
    tagline: "Modern car buying experience",
    image: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=600&h=400&fit=crop",
    logoBg: "#FDEFEC"
  },
  { 
    name: "Sanjeevani Aushadhi", 
    cat: "Healthcare", 
    url: "https://sanjeevaniaushadhi.in/", 
    color: "#1D8F86", 
    tagline: "Natural & herbal healthcare",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&h=400&fit=crop",
    logoBg: "#E3F6F4"
  },
  { 
    name: "Prakriti Masala", 
    cat: "Food & Spices", 
    url: "https://prakritimasala.com/", 
    color: "#E06C1F", 
    tagline: "Authentic Indian spice brand",
    image: "https://images.unsplash.com/photo-1532336414038-cf19250c5757?w=600&h=400&fit=crop",
    logoBg: "#FEF2E6"
  },
  { 
    name: "Secrotech International", 
    cat: "Technology", 
    url: "https://secrotech.com/", 
    color: "#4C51BF", 
    tagline: "Advanced security tech solutions",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop",
    logoBg: "#EBECFE"
  },
  { 
    name: "Suranjit Construction", 
    cat: "Construction", 
    url: "https://suranjitconstruction.com/", 
    color: "#6B5E4A", 
    tagline: "Building the future brick by brick",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=600&h=400&fit=crop",
    logoBg: "#F2EFEA"
  },
  { 
    name: "Rishi Samarpan", 
    cat: "NGO", 
    url: "https://rishisamarpan.com/", 
    color: "#C15F8C", 
    tagline: "Serving society, inspiring change",
    image: "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=600&h=400&fit=crop",
    logoBg: "#FDEEF4"
  }
];

// Client Card Component with Image
const ClientCard = ({ client, index }) => {
  const [hovered, setHovered] = React.useState(false);
  const [imageError, setImageError] = React.useState(false);
  
  // Get initials for logo fallback
  const getInitials = (name) => {
    return name.split(' ').slice(0, 2).map(word => word[0]).join('');
  };
  
  // Fallback images based on category
  const getFallbackImage = (category) => {
    const fallbacks = {
      "Astrology": "https://images.unsplash.com/photo-1536834478492-3e7da724b692?w=600&h=400&fit=crop",
      "Real Estate": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=400&fit=crop",
      "HR Services": "https://images.unsplash.com/photo-1568992687947-868a62a9f521?w=600&h=400&fit=crop",
      "E-Commerce": "https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=600&h=400&fit=crop",
      "Infotech": "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&h=400&fit=crop",
      "Automotive": "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=600&h=400&fit=crop",
      "Healthcare": "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=600&h=400&fit=crop",
      "Food & Spices": "https://images.unsplash.com/photo-1596040033229-a9821fbe1580?w=600&h=400&fit=crop",
      "Technology": "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=600&h=400&fit=crop",
      "Construction": "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600&h=400&fit=crop",
      "NGO": "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=600&h=400&fit=crop"
    };
    return fallbacks[category] || "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=400&fit=crop";
  };
  
  const imageUrl = imageError ? getFallbackImage(client.cat) : client.image;
  
  return (
    <motion.a
      href={client.url}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -8, transition: { duration: 0.2 } }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="group relative block bg-white rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 shadow-sm hover:shadow-2xl"
    >
      {/* Image Container */}
      <div className="relative h-48 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
        <img 
          src={imageUrl} 
          alt={client.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          onError={() => setImageError(true)}
          loading="lazy"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent" />
        
        {/* Category Badge on Image */}
        <span 
          className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1.5 rounded-full backdrop-blur-md shadow-lg z-10 border border-white/30"
          style={{ 
            background: `${client.color}dd`,
            color: 'white'
          }}
        >
          {client.cat}
        </span>
        
        {/* Logo/Initials Overlay */}
        <div 
          className="absolute bottom-3 left-3 w-11 h-11 rounded-xl flex items-center justify-center shadow-lg backdrop-blur-md border-2 border-white/50"
          style={{ background: `${client.color}ee` }}
        >
          <span className="text-white font-bold text-base">
            {getInitials(client.name)}
          </span>
        </div>
      </div>
      
      {/* Content */}
      <div className="p-5">
        <h3 className="text-base font-bold text-gray-900 mb-2 leading-tight transition-colors duration-200" style={{ color: hovered ? client.color : '#111827' }}>
          {client.name}
        </h3>
        
        <p className="text-sm text-gray-500 mb-4 leading-relaxed line-clamp-2">
          {client.tagline}
        </p>
        
        {/* Visit link */}
        <div 
          className="flex items-center gap-1.5 text-xs font-semibold transition-all duration-200"
          style={{ 
            color: client.color,
            opacity: hovered ? 1 : 0.7
          }}
        >
          <span>Visit website</span>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="transition-transform duration-200 group-hover:translate-x-1">
            <path d="M7 17L17 7M17 7H7M17 7v10" />
          </svg>
        </div>
      </div>
      
      {/* Bottom accent bar on hover */}
      <div 
        className="absolute bottom-0 left-0 right-0 h-0.5 transition-all duration-300 ease-out"
        style={{ 
          background: client.color,
          width: hovered ? '100%' : '0%'
        }}
      />
    </motion.a>
  );
};

// Main Section Component
export default function OurClientsSection() {
  const stats = [
    { value: "11+", label: "Live Projects", icon: "🚀" },
    { value: "100%", label: "On-Time Delivery", icon: "⏱️" },
    { value: "5.0★", label: "Client Rating", icon: "⭐" }
  ];
  
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white font-['Inter',system-ui,sans-serif]">
      <div className="max-w-[1280px] mx-auto px-6 md:px-8">
        
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 bg-emerald-50 border border-emerald-200 rounded-full px-4 py-1.5 mb-5">
            <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
            <span className="text-xs font-bold tracking-wide text-emerald-700">
              TRUSTED PARTNERS
            </span>
          </div>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-5 tracking-tight leading-tight">
            Turning visions into{' '}
            <span className="bg-gradient-to-r from-emerald-500 to-teal-600 bg-clip-text text-transparent">
              digital reality
            </span>
          </h2>
          
          <p className="text-base md:text-lg text-gray-500 max-w-2xl mx-auto mb-10 leading-relaxed">
            Trusted by industry leaders across the globe to craft high-performance 
            digital experiences that drive real results.
          </p>
          
          {/* Stats */}
          <div className="flex justify-center gap-4 flex-wrap">
            {stats.map((stat, idx) => (
              <motion.div 
                key={stat.label}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: idx * 0.1 }}
                whileHover={{ y: -2 }}
                className="bg-white border border-gray-200 rounded-full px-6 py-2.5 flex items-center gap-2 shadow-sm hover:shadow-md transition-all cursor-default"
              >
                <span className="text-xl">{stat.icon}</span>
                <span className="font-extrabold text-base text-emerald-600">{stat.value}</span>
                <span className="text-sm text-gray-600 font-medium">{stat.label}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
        
        {/* Client Grid - 4 columns on desktop, 2 on tablet, 1 on mobile */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {clients.map((client, idx) => (
            <ClientCard key={client.name} client={client} index={idx} />
          ))}
        </div>
        
        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-center mt-20"
        >
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl p-10 md:p-12 max-w-3xl mx-auto shadow-2xl">
            <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-1.5 mb-4">
              <span className="text-2xl">✨</span>
              <span className="text-xs font-semibold text-white/80 tracking-wide">LIMITED SLOTS AVAILABLE</span>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Let's build something exceptional together
            </h3>
            <p className="text-gray-400 text-sm mb-8 max-w-md mx-auto">
              Join our growing family of 11+ satisfied clients and experience digital excellence.
            </p>
            <motion.a
              href="#contact"
              whileHover={{ scale: 1.05, boxShadow: "0 20px 40px rgba(16,185,129,0.3)" }}
              whileTap={{ scale: 0.98 }}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white font-bold text-sm py-3.5 px-8 rounded-full shadow-lg hover:shadow-xl transition-all"
            >
              Start your project
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </motion.a>
          </div>
        </motion.div>
        
      </div>
    </section>
  );
}